/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import {  useDispatch, useSelector } from 'react-redux';
const Table = ({pageNumber, handleOnClickSort, sortValue, setConfirmationState, confirmationState, handleSidePopupClick,email,setLoading, searchParams}) => {
    const dispactch=useDispatch()
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const InstitutionUserList = useSelector(state => state.InstitutionUserSlice);
    const { List } = InstitutionUserList;

    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return (
        <div class="-mx-1">
            <div className={`flex mb-1 overflow-auto pr-2  ${List?.data?.length < 10 ? 'pb-[100px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result" >
                <table aria-label="Outside Table" className="w-full" id='admin-table'>
                    <thead>
                        <tr>
                            <th class="w-[23%]">
                                <span >Name
                                </span>
                            </th>
                            <th class="w-[20%]">
                                <span class="flex items-center justify-start break-al">Email Address
                                </span>
                            </th>
                            <th class="w-[14%]">
                                <span class="flex items-center">Mobile Number
                                </span>
                            </th>
                            <th class="w-[11%]">
                                <span >Created on
                                </span>
                            </th>
                            <th class="w-[10%]">
                                <span class="flex items-center justify-center">Status
                                </span>
                            </th>
                            <th class="w-[7%]">
                                <span class="flex items-center justify-center">Actions
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" className="h-1">
                        </tr>
                    </thead>
                    <tbody>
                        {List.data.map((item , index = 0) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    setConfirmationState={setConfirmationState}
                                    confirmationState={confirmationState}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List.data?.length}
                                    email={email}
                                    handleSidePopupClick={handleSidePopupClick}
                                />
                            </Fragment>
                        ))}
                        
                    </tbody>
                    {List?.data?.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="6" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No Users added yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
                
            </div>
        </div>
    );
}

export default Table;
